import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import L from 'leaflet';
import { MapComponent as NgLeafletMapComponent } from 'ng-leaflet-universal';
import { Marker } from 'ng-leaflet-universal/lib/models/marker.interface';

@Component({
  selector: 'sigecom-map',
  template: `
    <div class="map-wrapper">
      <ng-leaflet-universal #leafletMap></ng-leaflet-universal>
    </div>
  `,
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {

  @ViewChild('leafletMap') leafletMapComponent!: NgLeafletMapComponent;
  @Output() mapClick = new EventEmitter<{ latitude: number; longitude: number }>();
  @Input() initialLat?: number;
  @Input() initialLng?: number;

  mapLoaded = false;

  myMarker: Marker | null = null;

  constructor() { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.leafletMapComponent) {
        return;
      }
      this.mapLoaded = true;
      setTimeout(() => {
        if (this.leafletMapComponent.map) {
          if (this.initialLat && this.initialLng) {
            this.setMapPosition(this.initialLat, this.initialLng);
          } else {
            this.leafletMapComponent.map.setView([-15.7975, -47.8919], 13);
          }
          this.leafletMapComponent.map.invalidateSize();
          this.fixMapWidth();
          this.addMapClickEvent();
        }
      }, 1000);
    }, 1000);
    this.observeLayoutChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['initialLat'] || changes['initialLng']) && this.initialLat && this.initialLng) {
      if (this.mapLoaded && this.leafletMapComponent?.map) {
        this.updateMapPosition();
      } else {
        setTimeout(() => this.updateMapPosition(), 1000);
      }
    }
  }



  private updateMapPosition(): void {
    if (this.leafletMapComponent?.map) {
      if (this.initialLat !== undefined && this.initialLng !== undefined) {
        this.leafletMapComponent.map.setView([this.initialLat, this.initialLng], 15);
        this.addMarker(this.initialLat, this.initialLng);
        this.leafletMapComponent.map.invalidateSize();
      } else {
        this.leafletMapComponent.map.setView([-15.7975, -47.8919], 13);
      }
    }
  }


  private addMapClickEvent(): void {
    if (this.leafletMapComponent?.map) {
      this.leafletMapComponent.map.on('click', (event: L.LeafletMouseEvent) => {
        const latlng = event.latlng;
        this.addMarker(latlng.lat, latlng.lng);
        this.mapClick.emit({ latitude: latlng.lat, longitude: latlng.lng });
      });
    }
  }

  private addMarker(latitude: number, longitude: number): void {
    if (this.leafletMapComponent?.map) {
      this.myMarker = {
        id: "Localizacao selecionada",
        cardActivated: false,
        location: {
          latitude: latitude,
          longitude: longitude,
        },
      };
      this.leafletMapComponent.updateMarkers([this.myMarker]);
    }
  }
  setMapPosition(latitude: number, longitude: number): void {
    const updateMap = () => {
      if (this.leafletMapComponent?.map) {
        this.leafletMapComponent.map.setView([latitude, longitude], 15);
        this.addMarker(latitude, longitude);
        this.leafletMapComponent.map.invalidateSize();
      } else {
        setTimeout(updateMap, 500);
      }
    };
    updateMap();
  }



  // Ajusta a largura do mapa para evitar problemas de overflow
  private fixMapWidth(): void {
    setTimeout(() => {
      const leafletContainer = document.querySelector('.leaflet-container') as HTMLElement;
      if (!leafletContainer) {
        return;
      }
      leafletContainer.style.width = '100%';
      leafletContainer.style.maxWidth = 'none';
      if (this.leafletMapComponent?.map) {
        this.leafletMapComponent.map.invalidateSize();
      }
    }, 300);
  }

  // Monitora mudanças no layout e recria o mapa se houver mudança de estado, exemplo: abrir e fechar o menu lateral esquerdo
  private observeLayoutChanges(): void {
    let timeout: any;
    const updateMap = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (!this.leafletMapComponent?.map) {
          this.initializeMap();
          return;
        }
        this.leafletMapComponent.map.invalidateSize();
        this.fixMapWidth();
      }, 300);
    };
    window.addEventListener('resize', updateMap);
    window.addEventListener('scroll', updateMap);
    window.addEventListener('click', updateMap);
  }

  // Reinicia o mapa se necessário
  private initializeMap(): void {
    setTimeout(() => {
      if (!this.leafletMapComponent?.map) {
        this.leafletMapComponent.ngAfterViewInit();
      }
      if (this.leafletMapComponent?.map) {
        this.leafletMapComponent.map.setView([-15.7975, -47.8919], 13);
        this.leafletMapComponent.map.invalidateSize();
        this.fixMapWidth();
        this.addMapClickEvent(); // Re-adiciona o evento de clique ao reiniciar o mapa
      }
    }, 1000);
  }
}